module.exports = __webpack_public_path__ + "img/logo_phase03.d2030340.png";